<div style="flex: 1;"></div>
<ng-container *ngIf="checkItem.tasksTotal > 0">
	<span class="tasks-counter"
        (click)="openTasks($event, checkItem.id)">{{checkItem.tasksDone}}/{{checkItem.tasksTotal}}
    Tasks</span>
</ng-container>

<i class="pi pi-paperclip" style="font-size: 100%" *ngIf="checkItem.files?.length > 3"></i>
<ng-container *ngIf="checkItem.files?.length <= 3">
  <i class="pi pi-paperclip" style="font-size: 100%" *ngFor="let file of checkItem.files"
     (click)="openFile($event, file)"></i>
</ng-container>


<i class="pi pi-info-circle hover-info-icon" *ngIf="checkItem.toggledBy"
   (click)="checkItemNfs.toggle($event); $event.stopPropagation();"></i>


<p-overlayPanel #checkItemNfs appendTo="body" styleClass="client-nfs-op-block">
  <ng-template pTemplate>
    Toggled By: {{checkItem.toggledBy.name}},
    {{checkItem.toggleDate | date: 'MMM d, h:mm a'}}
  </ng-template>
</p-overlayPanel>
